<app-header></app-header>
<div class="container-fluid">
  <div id="content">
    <router-outlet></router-outlet>
  </div>
</div>
<footer>
  <span>{{version}}</span>
  <span>TCSC © {{year}}</span>
</footer>
